export default __webpack_public_path__ + "static/media/contact-us.b179c4f4.png";